<template>



    <div class="main-nav">
        <div class="nav-container">
            <div class="header-bar">
                <svg class="logo" viewBox="0 0 218.18 22" id="paychexbeta_logo" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M20.77 7.26c0-4.65-2.46-6.76-6.24-6.76H4.3L0 21.5h6.27l1.3-6.34h4.28c5.42.01 8.92-3.64 8.92-7.9zM11 10.16H8.61l.89-4.29h2.16c1.33 0 2.75.27 2.75 1.89 0 1.43-.83 2.4-3.41 2.4zM26.79.51l-11.92 21h6.47l1.59-3h6.73l.35 3h6.23L33 .51zM25.23 14l3.21-6.29h.06l.69 6.29h-4zM48.93.51l-5 7.82-2-7.82h-6.4L40 13.8l-1.56 7.7h6.35l1.56-7.76 10-13.23zm17 13c-.4 1.85-1.53 3.23-3.52 3.23-2.92 0-3.33-2.7-3.33-4.44 0-3 1.27-7.07 4.8-7.07 2 0 2.89 1.12 2.83 3.08h6C72.55 2 68.45 0 63.85 0c-7 0-11.19 5.66-11.19 12.44 0 5.56 2.89 9.56 8.87 9.56 8.58 0 10.2-6.34 10.58-8.48h-6.18zm22.63-13L87 7.86h-5.8L82.7.5h-6.32l-4.3 21h6.35l1.7-8.27h5.8l-1.7 8.27h6.35l4.35-21h-6.37zm38.24 0L122.68 6l-2-5.47H97.1l-4.31 21h23.76l4.76-5.87 2.28 5.87h7.13l-5-11.14L134.3.53h-7.54zm-16.31 19l.7-3.42h-10.94l.55-2.66h9.94l1-5h-9.91l.55-2.61h10.69L114 1l4.48 9.35zm38.14-10.27l1-4.85h7.78l3.37-3.88h-14.92l-4.44 21H146l1.85-8.67h6.26l3.1-3.59h-8.58zm13.92 8.38L166.14.5h-4.64l-4.41 21h12.26l3.32-3.88zm15.47 0l1.09-5.15 6.35-.07 3-3.52h-8.63l.94-4.5h7.8L191.82.5H177l-4.41 21h12.7l3.36-3.88h-10.63zM211.29.51h-5.47l-5.38 6.94-3-6.94h-5l4.91 9.94-9.56 11.05h5.59l6-7.5 3.29 7.5h5.09l-5.2-10.85zM215.18 0a3 3 0 0 0-3 3.07 3 3 0 0 0 3 3.07 3 3 0 0 0 3-3.07 3 3 0 0 0-3-3.07zm0 5.65a2.52 2.52 0 0 1-2.53-2.59 2.53 2.53 0 1 1 5.05 0 2.45 2.45 0 0 1-2.52 2.59zm1.38-3.43c0-.6-.36-1-1.14-1h-1.32v3.59h.42V3.25h.72l1 1.56h.48l-1-1.56c.48-.12.84-.36.84-1.02zm-1.44.6h-.54v-1.2h.78c.42 0 .84.12.84.6s-.54.61-1.08.61z" fill="#fff"></path></svg>
            </div>

            <div class="app-links">
                <div class="app-group-header">
                    <span>{{ labels.main[lang]}}</span>
                </div>
                <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="dashboard")'  @click="onNavLink('/employee/dashboard')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="dashboard" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M15 7a8 8 0 1 1-8 8 8 8 0 0 1 8-8m0-1a9 9 0 1 0 9 9 9 9 0 0 0-9-9z" ></path><circle cx="14.92" cy="9" r="1" ></circle><circle cx="21" cy="15" r="1" ></circle><circle cx="10.76" cy="10.76" r="1" ></circle><circle cx="19.24" cy="10.76" r="1" ></circle><circle cx="9" cy="15" r="1" ></circle><path d="M15 11s-2 6.9-2 8a2 2 0 0 0 4 0c0-1.1-2-8-2-8zm-.08 9a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>{{ labels.dashboard[lang]}}</span>
                    </div>
                </div>
              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="myprofile")' @click="onNavLink('/employee/myprofile')">
                    <div class="app-link-icon">
                      <svg viewBox="0 0 30 30" id="my-profile" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><g><path d="M11.415 16.561v-.396a2.202 2.202 0 0 0 1.076-1.898v-.552c0-1.219-.963-2.205-2.152-2.205-1.19 0-2.155.986-2.155 2.205v.551c0 .814.436 1.516 1.079 1.898v.396c-1.856.305-3.232 1.381-3.232 2.664v.551c0 .305.242.551.539.551h7.54a.544.544 0 0 0 .539-.551v-.551c-.003-1.283-1.377-2.359-3.234-2.663M24.086 12.98a.732.732 0 0 1-.722.734h-5.063a.734.734 0 0 1-.724-.734c0-.404.325-.736.724-.736h5.063c.396 0 .722.332.722.736zM24.086 15.918a.73.73 0 0 1-.722.734h-3.62a.732.732 0 0 1-.723-.734.73.73 0 0 1 .723-.734h3.62a.73.73 0 0 1 .722.734zM24.086 18.857a.73.73 0 0 1-.722.732h-5.063a.732.732 0 0 1-.724-.732c0-.404.325-.736.724-.736h5.063c.396 0 .722.332.722.736z"></path><path d="M25.979 7.838h-9.193l.182-1.113c.066-.399-.204-.725-.601-.725h-2.89c-.396 0-.667.326-.602.725l.182 1.113H3.865c-.794 0-1.443.66-1.443 1.469v13.225c0 .808.649 1.468 1.443 1.468h22.113c.793 0 1.442-.66 1.442-1.469V9.307c.002-.809-.649-1.469-1.441-1.469zm-9.745-1.104l-.463 2.828c-.008.045-.084.111-.129.111h-1.444c-.044 0-.121-.066-.128-.111l-.463-2.828h2.627zm9.745 15.797H3.865V9.307h9.432l.063.377c.063.4.443.725.838.725h1.444c.396 0 .775-.324.84-.725l.063-.377h9.436v13.224h-.002z"></path></g></svg>
                    </div>
                    <div class="app-link-label">
                        <span>{{ labels.myProfile[lang]}}</span>
                    </div>
                </div>





              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="mypay")' @click="onNavLink('/employee/mypay')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="payroll" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M16.48 13.13c-.66-.24-1.3-.52-1.22-1a1.19 1.19 0 0 1 1.32-.72 2.77 2.77 0 0 1 1.87.77l.26.24 2-3.07-.21-.17a6.09 6.09 0 0 0-2.81-1L18 6h-2.2l-.33 2.13a5.13 5.13 0 0 0-4.2 4.33c-.37 2.34 1.07 3.23 2.36 3.75l.81.29c1.07.36 1.52.57 1.45 1a1.49 1.49 0 0 1-1.52 1 4 4 0 0 1-2.67-1.36l-.26-.28-2.18 3.2.16.18a5.18 5.18 0 0 0 2 1.23 6 6 0 0 0 1.92.44L13 24h2.2l.35-2.24c2.54-.67 4-2.12 4.33-4.46.44-2.81-1.75-3.59-3.41-4.18" ></path><path d="M16.48 13.13c-.66-.24-1.3-.52-1.22-1a1.19 1.19 0 0 1 1.32-.72 2.77 2.77 0 0 1 1.87.77l.26.24 2-3.07-.21-.17a6.09 6.09 0 0 0-2.81-1L18 6h-2.2l-.33 2.13a5.13 5.13 0 0 0-4.2 4.33c-.37 2.34 1.07 3.23 2.36 3.75l.81.29c1.07.36 1.52.57 1.45 1a1.49 1.49 0 0 1-1.52 1 4 4 0 0 1-2.67-1.36l-.26-.28-2.18 3.2.16.18a5.18 5.18 0 0 0 2 1.23 6 6 0 0 0 1.92.44L13 24h2.2l.35-2.24c2.54-.67 4-2.12 4.33-4.46.44-2.81-1.75-3.59-3.41-4.18" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>{{ labels.myPay[lang]}}</span>
                    </div>
                </div>

              <div v-if="$store.state.company === 'enterprise'" class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="mydocs")' @click="onNavLink('/employee/mydocs')">
                <div class="app-link-icon">
                  <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>documents</title><path d="M21.33 21.66a.57.57 0 0 1-.5.62h-9.59a.58.58 0 0 1-.53-.61V10.59a.58.58 0 0 1 .5-.63h7.56v1.94a.53.53 0 0 0 .46.5h2.1zm-12-1.74H9a.57.57 0 0 1-.54-.6V8.4A.57.57 0 0 1 9 7.78h9.7a.58.58 0 0 1 .54.62v.41H10.1a.54.54 0 0 0-.53.51v10.6zM20.25 9.76V7.25a.53.53 0 0 0-.53-.51H7.77a.49.49 0 0 0-.22.18.44.44 0 0 0-.09.31v13.2a.54.54 0 0 0 .54.5h1.6v1.86a.53.53 0 0 0 .53.5H22a.53.53 0 0 0 .53-.5V11.7z"></path><path d="M12.02 14.85h6v-1h-6v1z"></path><path d="M19.25 16.85h-7.23v1h8v-1h-.77z"></path><path d="M12.02 18.85v1h8v-1h-8z"></path></svg>                </div>
                <div class="app-link-label">
                  <span>{{ labels.myDocuments[lang]}}</span>
                </div>
              </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="myperks")' @click="onNavLink('/employee/myperks')">
                <div id="myPerks" class="app-link-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 20 20">
                    <defs>
                      <clipPath id="clip-path">
                        <rect id="Rectangle_22" data-name="Rectangle 22" width="20" height="20" fill="#fff"/>
                      </clipPath>
                    </defs>
                    <g id="icon" clipPath="url(#clip-path)">
                      <path id="Path_12" data-name="Path 12" d="M19,8.58V8.52l-.55-5.21a1.846,1.846,0,0,0-1.76-1.76l-5.21-.54h-.12a2.775,2.775,0,0,0-1.98.82L1.58,9.62a1.98,1.98,0,0,0,0,2.8l6,6a1.98,1.98,0,0,0,2.8,0l7.8-7.8A2.776,2.776,0,0,0,19,8.64ZM17.36,9.8l-7.8,7.8a.821.821,0,0,1-1.16,0l-6-6a.821.821,0,0,1,0-1.16l7.8-7.8a1.643,1.643,0,0,1,1.16-.48l5.25.54a.681.681,0,0,1,.68.68l.54,5.25a1.609,1.609,0,0,1-.48,1.16Z"  stroke-miterlimit="10" stroke-width="0.5"/>
                      <path id="Path_13" data-name="Path 13" d="M13.02,10.79,11.3,9.59l.07-2.14a.223.223,0,0,0-.1-.18.18.18,0,0,0-.2.02L9.33,8.6,7.31,7.95a.214.214,0,0,0-.2.05.208.208,0,0,0-.05.2l.65,2.02L6.4,11.96a.206.206,0,0,0-.02.2.181.181,0,0,0,.18.1l2.14-.07,1.2,1.72a.209.209,0,0,0,.16.08h.03a.183.183,0,0,0,.15-.13l.67-2.06,2.06-.68a.183.183,0,0,0,.13-.15.209.209,0,0,0-.08-.19Z"  stroke-miterlimit="10" stroke-width="0.5"/>
                      <path id="Path_14" data-name="Path 14" d="M14.64,3.73a1.79,1.79,0,1,0,1.79,1.79A1.788,1.788,0,0,0,14.64,3.73Zm0,2.82a1.02,1.02,0,1,1,1.02-1.02A1.018,1.018,0,0,1,14.64,6.55Z"  stroke-miterlimit="10" stroke-width="0.5"/>
                    </g>
                  </svg>
                </div>
                <div class="app-link-label">
                  <span>My Perks</span>
                </div>
              </div>


                <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="directory")' @click="onNavLink('/employee/directory')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="people" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>applicationIcons</title><path d="M19.8 10.25a1.75 1.75 0 0 1 .1 3.5 1.84 1.84 0 0 1-1.8-1.7 1.65 1.65 0 0 1 1.7-1.8m0-1a2.75 2.75 0 1 0 2.7 2.8 2.78 2.78 0 0 0-2.7-2.8zM12.4 8.15a3 3 0 0 1 2.9 3 2.9 2.9 0 1 1-5.8.3v-.3a3 3 0 0 1 2.9-3m0-1a3.93 3.93 0 0 0-3.9 4 3.85 3.85 0 0 0 3.7 4.1 3.91 3.91 0 0 0 4.1-3.7v-.4a3.93 3.93 0 0 0-3.9-4zM25.8 19.35a3 3 0 0 0-1-2 7.09 7.09 0 0 0-5-1.7 8.42 8.42 0 0 0-2.7.4 9.44 9.44 0 0 0-.9.3 8.22 8.22 0 0 0-3.8-.6 11.93 11.93 0 0 0-3.7.6 6.91 6.91 0 0 0-4 3.1 3.87 3.87 0 0 0-.5 2.4.92.92 0 0 0 .9 1h14.4c1 0 1.2-1 1-2H25c.8 0 .9-.85.8-1.5zM19.6 21a1.39 1.39 0 0 1 0 .9H5.2v-.1a2.78 2.78 0 0 1 .3-1.8A6.34 6.34 0 0 1 9 17.25a10.24 10.24 0 0 1 3.5-.5 12.41 12.41 0 0 1 2.7.3 4.87 4.87 0 0 1 1.1.4 6.36 6.36 0 0 1 2.2 1.4 3.92 3.92 0 0 1 .8 1c.1.3.2.7.3 1.1zm5.2-1.1h-4.5a4.52 4.52 0 0 0-1.1-1.7 6.57 6.57 0 0 0-1.7-1.2 9.69 9.69 0 0 1 2.3-.3 6.13 6.13 0 0 1 4.3 1.5 2.22 2.22 0 0 1 .8 1.3.76.76 0 0 0-.1.35z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Company Directory</span>
                    </div>
                </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="locations")' @click="onNavLink('/employee/locations')">
                <div class="app-link-icon">
                  <svg viewBox="0 0 30 30" id="company_cache56" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M24.09 11.43h-.8v-1.15a.44.44 0 0 0-.44-.43H21.3V7.92a.64.64 0 0 0-1.28 0v1.93h-.7v2.44h4.08v.92h-4.09v1.19h4.09v.92h-4.09v1.18h4.09v.92h-4.09v1.18h4.09v.92h-4.09v1.18h4.09v.93h-4.09V24h5.22V11.87a.44.44 0 0 0-.44-.44zM17.2 6.52h-.32v-.09a.44.44 0 0 0-.44-.43H6.67a.44.44 0 0 0-.44.43v.09h-.32a.44.44 0 0 0-.44.48v17h12.17V7a.44.44 0 0 0-.44-.48zm-5.91 14.2H6.64v-2h4.64v2zm0-3.18H6.64v-2h4.64v2zm0-3.18H6.64v-2h4.64v2zm0-3.18H6.64v-2h4.64v2zm5.18 9.55h-4.65v-2h4.64v2zm0-3.18h-4.65v-2h4.64v2zm0-3.18h-4.65v-2h4.64v2zm0-3.18h-4.65v-2h4.64v2z" ></path></svg>                </div>
                <div class="app-link-label">
                  <span>Company Locations</span>
                </div>
              </div>

              <div v-if="$store.state.company === 'enterprise'" class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="performance")' @click="onNavLink('/employee/performance')">
                <div class="app-link-icon">
                  <svg class="cvperformance" viewBox="0 0 30 30" id="performance_cache57" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>performance</title><path d="M21 7h-1v2a.94.94 0 0 1-1 1h-9a.89.89 0 0 1-1-1V7H8a.94.94 0 0 0-1 1v15a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm0 16H8V11h13z" ></path><path d="M18.4 9h-7.9c-.3 0-.5-.2-.5-.6V5.6a.53.53 0 0 1 .6-.6h7.9c.3 0 .5.2.5.6v2.9c0 .3-.2.5-.6.5z" ></path><path d="M14.5 5.9a.77.77 0 0 1-.8-.7v-.5a.68.68 0 0 1 .7-.7.68.68 0 0 1 .7.7v.4c.2.4-.2.8-.6.8zM14.5 17a2.48 2.48 0 0 0 2.5-2.5 2.61 2.61 0 0 0-1.3-2.2 2.55 2.55 0 0 0-2.4 0 2.37 2.37 0 0 0-1.3 2.2 2.48 2.48 0 0 0 2.5 2.5zM14.5 18q-3.6 0-4.5 3h9q-.9-3-4.5-3z"></path></svg>
                </div>
                <div class="app-link-label">
                  <span>Performance</span>
                </div>
              </div>





              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="expense")'  @click="openTab('/#/expense-wire-mobile/expense-home')">
                <div class="app-link-icon expense-management">
                  <svg kui-icon="g-app-glyph-expense-management" viewBox="0 0 20 20" aria-hidden="true"   height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"  data-payxautoid="paychex.app.landing.shared.application-icon.EXPMGTEMPR">
                    <symbol id="g-app-glyph-expense-management" viewBox="0 0 20 20"><path d="M16.5 1H2c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h13c.55 0 1-.45 1-1v-4h2c.55 0 1-.45 1-1V3.5A2.5 2.5 0 0 0 16.5 1ZM14 17H3V3h11v14Zm3-5h-1V3.41c.05-.23.25-.41.5-.41h.09c.23.05.41.25.41.5V12Z"></path><path d="M13 13.5H4v2h9v-2ZM5.88 12h1.25v-1.25h.42c.82-.06 1.46-.73 1.46-1.56 0-.83-.7-1.56-1.56-1.56H5.52a.32.32 0 0 1-.26-.31v-.06A.32.32 0 0 1 5.57 7h2.81V5.75H7.13V4.5H5.88v1.25l-.62.03c-.71.14-1.25.78-1.25 1.53 0 .86.7 1.56 1.56 1.56H7.5c.15.03.26.16.26.31v.06a.32.32 0 0 1-.31.26H4.01v1.25h1.88V12h-.01ZM13 10h-3v2h3v-2Zm0-2.75h-3v2h3v-2Zm0-2.75h-3v2h3v-2Z"></path></symbol>
                    <use href="#g-app-glyph-expense-management"></use>
                  </svg>
                </div>
                <div class="app-link-label">
                  <span>Expense Management</span>
                </div>
              </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="time")' @click="onNavLink('/employee/time-overview')">
                <div class="app-link-icon">
                  <svg viewBox="0 0 30 30" id="time-and-attendance" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M15 6a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 16.54A7.54 7.54 0 1 1 22.54 15 7.55 7.55 0 0 1 15 22.54z" ></path><path d="M16 15.32a1 1 0 0 0 0-.71 1 1 0 0 0-.56-.55V9.9h-.83v4.17a1 1 0 1 0 1.12 1.64l4.55 3.05.25-.37z" ></path></svg>                </div>
                <div class="app-link-label">
                  <span>{{ labels.timeAttendance[lang]}}</span>
                </div>
              </div>

              <div class="app-link hidden">
                <div class="app-link-icon">
                  <svg viewBox="0 0 30 30" id="benetrac_cache9" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M13 21.7a6.85 6.85 0 0 1-1.6-.68l-2.1 1.05-1.37-1.41 1-2.1a7 7 0 0 1-.75-1.81L6 16v-2l2.23-.74A7 7 0 0 1 9 11.44l-1.07-2.1 1.41-1.41L11.44 9a7 7 0 0 1 1.81-.75L14 6h2l.74 2.23a6.91 6.91 0 0 1 1.82.77l2.1-1.05 1.41 1.42-1 2.1a7 7 0 0 1 .79 2l2.14.66v2l-1.5.5v-.13A3.5 3.5 0 0 0 19 13a3.36 3.36 0 0 0-.53.05A4 4 0 1 0 16 18.86c0 .06 0 .14.08.14-1.69.57-2.81 1.54-3.08 2.7zm11 .42c0-1.12-1.59-2.12-3.75-2.41v-.43a2.49 2.49 0 0 0 1.25-2.15v-.63a2.5 2.5 0 0 0-5 0v.63a2.49 2.49 0 0 0 1.25 2.15v.43C15.59 20 14 21 14 22.13v.63A1.25 1.25 0 0 0 15.25 24h7.5A1.25 1.25 0 0 0 24 22.75v-.62z" fill="#7c8d99"></path></svg>                </div>
                <div class="app-link-label">
                  <span>Benefits Administration</span>
                </div>
              </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="retirement")' @click="onNavLink('/employee/retirement-summary')">
                <div class="app-link-icon">
                  <svg viewBox="0 0 30 30" id="retirement-services_cache10" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>retirement-services</title><path d="M27.71 6.55c0-.08-.13-.16-.23-.13l-.08.06a1.68 1.68 0 0 0-.21.41 1.73 1.73 0 0 1-.26.38 1.36 1.36 0 0 1-.44.34l-.35.12a3.15 3.15 0 0 0-.38-1.91A2.1 2.1 0 0 0 24 4.89a2 2 0 0 0-1.13.35 2 2 0 0 0-.7 2.33 2.05 2.05 0 0 0 1 1.06c.67-.64.93-1 .71-1.35s-.27-.51-.05-.67.49 0 .64.25c.51.74-.93 2.08-1.31 2.52a13.11 13.11 0 0 0-1.16-1 10.74 10.74 0 0 0-6.14-2.26 6.18 6.18 0 0 0-.66 0 11.55 11.55 0 0 0-4.75 1 1.56 1.56 0 0 0-1-.84A3.87 3.87 0 0 0 7.9 6c-.56 0-1.36.24-1.94.31s-.61.53-.27.94l1.57 2c-2.11 2-2.07 3.69-2.92 4.15a3.6 3.6 0 0 1-1.3.38c-.84.09-1.12.41-1 1.21s.18 1.52.3 2.28a1.46 1.46 0 0 0 1.51 1.35c1.35.13 1.18.2 2.42 1.37a10.25 10.25 0 0 0 1.43 1.36v2.31c0 1.05.41 1.43 1.19 1.45h1.73a1.25 1.25 0 0 0 1.21-1l.11-.5a10.62 10.62 0 0 0 3.46.66h.23a11 11 0 0 0 3.42-.66l.12.55a1.18 1.18 0 0 0 1.17.93h1.82c.73 0 1.15-.6 1.15-1.4 0-.57-.1-2-.16-2.82a8.36 8.36 0 0 0 2.15-5.81 8.08 8.08 0 0 0-.53-2.62 9.75 9.75 0 0 0-.67-1.64l1.16-1.3a1.07 1.07 0 0 1 .55-.37c.65-.06 1.41.08 1.86-.53a1.91 1.91 0 0 0 .04-2.05zm-6.38 14.31c.07.84.11 1.57.13 2.05a.31.31 0 0 1-.29.33h-.35a.32.32 0 0 1-.32-.25l-.31-1.36a.29.29 0 0 0-.35-.23l-1.49.5a8.47 8.47 0 0 1-5.82 0l-1.24-.47a.45.45 0 0 0-.57.28v.05l-.25 1.17a.35.35 0 0 1-.35.28h-.3a.34.34 0 0 1-.34-.34v-2.2a.63.63 0 0 0-.24-.5l-.38-.29c-.84-.65-1.49-1.5-2.31-2.16a3.14 3.14 0 0 0-.93-.57c-.27-.1-1-.08-1.23-.24l-.19-.2c-.05-.32-.09-.64-.13-1a.46.46 0 0 1 .31-.48 4.54 4.54 0 0 0 1-.41A3.67 3.67 0 0 0 6.89 13a7 7 0 0 1 1.63-2.37c3.58-3.37 11.18-3.8 13.94 1a7.89 7.89 0 0 1 1 4.4 6.66 6.66 0 0 1-1.68 3.66l-.31.35a.5.5 0 0 0-.13.36z" ></path><path d="M15.52 14.13c-.33-.11-.93-.3-.93-.73s.39-.53.84-.53a2 2 0 0 1 1.19.46l.66-1.33a3.83 3.83 0 0 0-1.68-.56v-1.16h-.84v1.12a2.15 2.15 0 0 0-2 2.25 1.86 1.86 0 0 0 1.48 1.84c.73.27 1.5.38 1.5.93s-.49.69-.88.69a2.77 2.77 0 0 1-1.68-.79l-.77 1.42a3.37 3.37 0 0 0 1.11.62 3.37 3.37 0 0 0 1.21.24v1.12h.84V18.5a2.22 2.22 0 0 0 2-2.32c.01-1.3-.99-1.69-2.05-2.05z"></path></svg>
                </div>
                <div class="app-link-label">
                  <span>{{ labels.myRetirement[lang]}}</span>
                </div>
              </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="hb")' @click="onNavLink('/employee/hb-summary')">
                <div class="app-link-icon">
                  <svg viewBox="0 0 30 30" id="health-and-benefits_cache11" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M16.06 13.1a1.21 1.21 0 0 0 1-.94 1 1 0 0 0-.65-1 2.8 2.8 0 0 0-.9-.27v2.27h.2l.31-.06m6.38-5.65A26 26 0 0 0 15.15 6 29.46 29.46 0 0 0 7.6 7.45s-.87 8.45 2.56 13C12.52 23.52 14.92 24 15 24c.07 0 2.47-.48 4.84-3.59 3.43-4.51 2.56-13 2.56-13m-5.63 9a.86.86 0 0 1 .9.6 1.2 1.2 0 0 1-.79 1.16 4 4 0 0 0-1.33 1.05v1.18h-.8a3.42 3.42 0 0 1-.3-1 1.1 1.1 0 0 1 .3-.77V17c-1.46-.43-2.2-1-2.2-1.73 0-.9.74-1.54 2.2-1.93V11A2.33 2.33 0 0 0 13 12.78l-.27-1-.88.33v-.15a3 3 0 0 1 2.35-2.19 1.08 1.08 0 0 1-.09-.44 1 1 0 1 1 2.08 0 1.16 1.16 0 0 1-.12.52 2.73 2.73 0 0 1 2.13 2.24c0 1.1-.75 1.82-2.1 2l-.54.1v2a8.58 8.58 0 0 0 1.22.21m-3.28-1.14c0 .15.34.42 1.26.72v-1.6c-.81.26-1.26.57-1.26.89M15.55 18a10.1 10.1 0 0 1 .94-.58c-.23 0-.56-.08-.94-.17V18z"></path></svg>                </div>
                <div class="app-link-label">
                  <span>{{ labels.health[lang]}}</span>
                </div>
              </div>
              <hr class="app-group-header" />

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="benadmin")' @click="openTab('/#/employeeflock/flock-benefits')">
                <div class="app-link-icon">
                  <svg viewBox="0 0 20 22" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M19 4v13a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4h18zm-2 2H3v10h14V6zm-6 1v3h3v2h-3.001L11 15H9l-.001-3H6v-2h3V7h2zm2.382-6a1 1 0 0 1 .894.553L15 3H1V2a1 1 0 0 1 1-1h11.382z" ></path></svg>
                </div>
                <div class="app-link-label">
                  <span>My Benefits</span>
                </div>
              </div>


                <hr class="app-group-header" />
                <div class="app-group-header">
                    <span>{{ labels.other[lang]}}</span>
                </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="help")' @click="onNavLink('/employee/help-center')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="help" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M24 15a9 9 0 0 0-18 0 9 9 0 0 0 18 0zm-7.88 4.9a.55.55 0 0 1-.56.55h-1.12a.55.55 0 0 1-.56-.55v-1.09a.55.55 0 0 1 .56-.55h1.13a.55.55 0 0 1 .56.55v1.09zm0-4v.73a.55.55 0 0 1-.56.55h-1.12a.55.55 0 0 1-.56-.55V15c0-.6.14-1.09.84-1.09h.84a.55.55 0 0 0 .56-.55v-1.08a.55.55 0 0 0-.56-.54h-1.12a.55.55 0 0 0-.56.54.54.54 0 0 1-.56.55h-1.13a.44.44 0 0 1-.52-.54 3.39 3.39 0 0 1 6.7.54 3.27 3.27 0 0 1-2.25 3.07z"></path></svg>
                    </div>
                    <div class="app-link-label ">
                        <span>{{ labels.help[lang]}}</span>
                    </div>
                </div>


            </div>
        </div>

    </div>


</template>

<script>
    export default {
        name: "flex-admin-side-nav",
        props: {
            activeLink: {
                type: String,
                required: false,
                default: null
            },
          lang: {
              default: "en"
          }
        },
        data: function () {
            return {
              labels: {
                main: {
                  en: "MAIN",
                  es: "PRINCIPAL"
                },
                dashboard: {
                  en: "Dashboard",
                  es: "Panel de control"
                },
                myProfile: {
                  en: "My Profile",
                  es: "Mi Perfil"
                },
                myPay: {
                  en: "My Pay",
                  es: "Mi Pago"
                },
                myDocuments: {
                  en: "My Documents",
                  es: "Mis documentos"
                },
                hr: {
                  en: "Human Resources",
                  es: "Compañía Localizaciones"
                },
                timeAttendance: {
                  en: "Time & Attendance",
                  es: "Tiempo & Asistencia"
                },
                myRetirement: {
                  en: "My Retirement",
                  es: "Mi Jubilación"
                },
                health: {
                  en: "Health & Benefits",
                  es: "Salud y Beneficios"
                },
                help: {
                  en: "Help Center",
                  es: "Centro de Ayuda"
                },
                other: {
                  en: "OTHER",
                  es: "OTROS"
                }
              }

            }
        },
        methods: {
          openTab: function(url){


            this.$screens.showExternalPage({
              target: {
                dataset: {
                  tgt: url,
                  tgtQuery: true
                }
              }
            })


          },
          onNavLink: function(url){
            let isExternal =  url.startsWith("http");
            if(isExternal){
              window.open(url,"_blank");
            }else{
              this.$store.commit("clearPanels");
              this.$router.push(url);
            }

          }
        },
        computed: {
          activeAppLink: function(){
            if(this.$route.params.screen){
              return this.$route.params.screen.split("-")[0];
            }else{
              return "dashboard";
            }
          }


        }
    }
</script>

<style scoped>




    .main-nav {
        font-size: 0.9em;
        position: absolute;
        width: calc((225/1580) * 100%);
        box-sizing: border-box;
        background-color: white;
        top: 0;
        height: 0;
        padding-bottom: calc((920/1580) * 100%);


        font-family: "Helvetica", "Arial", sans-serif;
        -webkit-font-smoothing: antialiased;

    }

    .nav-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }


    .icon-container svg {
        position: relative;
        height:100%;
        width: 30px;

    }

    .icon-container svg.help-svg {
        width: 24px;

    }





    .header-bar {
        position: relative;
        width: 100%;
        height: calc((60/920) * 100%);
        background-color: #0369b1;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .header-bar .logo {
        position: relative;
        width: calc((180/225) * 100%);
        height: calc((20/60) * 100%);

    }



    .app-group-header {
        font-size: 0.9em;
        margin: 0.9em;
        color: #7c8d99;
        box-sizing: border-box;
    }

    hr.app-group-header {
        border: 0;
        height: 1px;
        background-color: #D8D8D8;
        margin: calc((10/225) * 100%) calc((20/225) * 100%);
    }

    .app-links {
        position: relative;
        height: calc(((920 - 107)/920) * 100%);

    }

    .app-link {
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-items: center;
        height: calc((40/(920 - 107)) * 100%);
        width: 100%;
        box-sizing: border-box;
        padding: calc((10/225) * 100%);
        padding-left: calc((14/225) * 100%);
        color: #7c8d99;
        cursor: pointer;
        fill: #7c8d99;


    }

    .app-link svg {

        cursor: pointer;
    }

    .app-link-icon {
        position: absolute;
        display: block;
        width: calc((30/225)*100%);
        height: calc((30/40)*100%);
        cursor: pointer;

    }

    #myPerks.app-link-icon {

      width: calc((20/225)*100%);
      height: calc((20/40)*100%);
      margin-left: 0.2em;


    }


    .app-link-label {

        padding-left: calc((40/225) * 100%);
        cursor: pointer;

    }

    .app-link:hover {
        color: #0369b1;
        fill: #0369b1;
    }

    .app-link:hover .app-link-icon svg {

    }

    .app-link.link-disabled {
        cursor: default;
        pointer-events: none;
    }

    .app-link[data-selected="true"]{
        background-color: #f3f7fa;
        color: #0369b1;
        fill: #0369b1;
    }

    .app-link[data-selected="true"]:before {
        content: "";
        width: calc((5/225) * 100%);
        background-color: rgb(3, 105, 177);
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;

    }

    .hidden {
        display: none;
    }

    .app-link-icon {
      position: absolute;
      display: block;
      width: calc((26/225)*100%);
      height: calc((26/40)*100%);
      cursor: pointer;

    }

    .app-link-icon.expense-management {
      position: absolute;
      display: block;
      width: calc((20/225)*100%);
      height: calc((20/40)*100%);
      cursor: pointer;
      margin-left: calc((5/225)*100%);

    }

</style>
